import { Component, inject, input, output } from "@angular/core";
import { DateInputModel, Option } from "@app/filter-menu/filter-types";
import { WkDateFormat } from "../date-format";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { JumpstartComponentsModule as JumpstartComponentsModule_v3 } from "@wk/components-v3-angular17";
import { DueOnDatesComponent } from "../due-on-dates/due-on-dates.component";

@Component({
    selector: "wk-fm-target-end-dates",
    templateUrl: "./target-end-dates.component.html",
    styleUrl: "./target-end-dates.component.scss",
    imports: [JumpstartComponentsModule_v3, TranslateModule, DueOnDatesComponent],
})
export class TargetEndDatesComponent {
    protected readonly WkDateFormat = WkDateFormat;
    private readonly translateService = inject(TranslateService);

    selection = input<Option>();
    dueOnModel = input.required<DateInputModel>();
    fromModel = input.required<DateInputModel>();
    toModel = input.required<DateInputModel>();

    dueOnChange = output<string>();
    fromChange = output<string>();
    toChange = output<string>();

    currentLanguage = "en-CA";

    constructor() {
        this.currentLanguage = this.translateService.getCurrentLang()
            ? this.translateService.getCurrentLang()
            : this.translateService.getFallbackLang();
    }

    disabledFromDates = (dates: Date[]): Date[] => {
        const toDate = this.toModel().date;
        if (!toDate) return [];
        const to = new Date(toDate);
        to.setHours(0, 0, 0, 0);
        return dates.filter((date: Date) => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            return d > to;
        });
    };

    disabledToDates = (dates: Date[]): Date[] => {
        const fromDate = this.fromModel().date;
        if (!fromDate) return [];
        const from = new Date(fromDate);
        from.setHours(0, 0, 0, 0);
        return dates.filter((date: Date) => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            return d < from;
        });
    };
}
